import { createContext } from "react";

// Create a context with an initial value (could be any type)
export const FormContext = createContext<any>({});
